export class ShowQRModel {

    uid: string;
    show: boolean;

    constructor() {
        this.show = false;
     }
}
